import { Controller } from 'stimulus';

const DISABLED_CLASSES = ['pointer-events-none', 'opacity-50', 'dropdown-menu__link--disabled'];

// Enables the board-download link once the `designs--lazy-loading` controller (bound on the
// board's thumbnail figure) reports that screenshot generation has finished.
export default class extends Controller {
  enable(event) {
    const { data } = event.detail;

    this.element.href = data.download_url;
    this.element.classList.remove(...DISABLED_CLASSES);
  }
}
